
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#CE1126","d":"M0 0h30v18H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0l20.825 18H30L9.175 0z"}}),_c('path',{attrs:{"d":"M1.53 0l20.824 18h6.117L7.646 0z"}})])
          )
        }
      }
    